<template>
    <section class="bg-light-blue-03 px-content py-20 xl:py-[96px] relative will-change" :data-scroll-section="inner == 'false'">
        <h4 class="text-4xl xl:text-heading mb-8 xl:mb-16 text-navy-blue-01" v-show="blockData.title">{{ blockData.title }}</h4>

        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-x-10 xl:gap-x-[100px] w-full">
            <div class="flex items-start mb-9 xl:mb-16" v-for="(item, index) in blockData.items" :key="index">
                <img class="mr-8" v-show="item.icon" :src="item.icon.url" :alt="item.icon.alt" >   
                <div>
                    <div class="mb-2 mt-1 font-bold leading-none text-navy-blue-02" v-show="item.title">{{ item.title }}</div>
                    <div class="link-style text-navy-blue-02 break-all" v-show="item.text" v-html="item.text"></div>
                </div>
            </div>

        </div>

    </section>
</template>


<script>
    export default {
        name: 'Contact',
        data() {
            return {}
        },
        mounted() {

        },
        methods: {

        },
    }
</script>
